import { gql } from '@apollo/client';

export interface Input {
  copyFormName: string;
  formId: number;
  settingsToDuplicate: string[];
  organizationId: number;
  toScopeId: number;
  toScopeType: string;
}

export const MUTATION = gql`
  mutation DuplicateReg2Form($input: DuplicateReg2FormInput!) {
    duplicateReg2Form(input: $input) {
      id
    }
  }
`;
